<div *ngIf="plan">
  <ion-item-group class='plan-fields' *ngIf="!detailsOnly">
    <ind-section-header [viewData]="overviewHeaderModel" (onFilterClick)="onFilterControlClick($event)" (onControlClick)="onSectionHeaderControlClick($event)">
    </ind-section-header>
    <div class="overview">
      <div class="goal" *ngFor="let plan of goals; trackBy: trackById">
        <div class="goal-primary">
          <label class="title"> {{ plan.title | translate}}</label>
          <span class="percentage info" [ngStyle]="goalStyleFor(plan.actual, plan.goal)"> {{ goalPercentageLabel(plan.actual, plan.goal) }}</span>
        </div>
        <div class="goal-secondary">
          <label class="title">{{'GOAL' | translate}}</label>
          <span class="info">{{ plan.actual }}/{{ plan.goal }}</span>
        </div>
        <call-plan-progress-bar [progressHeight]="3" [backgroundHeight]="1" [displayPercentage]="false"
          [progress]="progressValue(plan.actual, plan.goal)" [barColor]="goalBarColor(plan.actual, plan.goal)"
          [label]=""> </call-plan-progress-bar>
      </div>
    </div>
  </ion-item-group>
  <ion-item-group [ngClass]="{'margin-bottom-above-fab': !detailsOnly && footerService.shouldApplyBottomMargin()}">
    <ind-section-header [viewData]="allCustomerPlansHeaderModel" (onFilterClick)="onFilterControlClick($event)" (onControlClick)="onDetailsHeaderControlClick($event)">
    </ind-section-header>
    <div class="no-data-message no-current-plans" *ngIf="previewRows && hasNoCurrentPlans" data-testid="contact-plan-no-current">
      <span>{{ 'NO_CURRENT_CALL_PLANS' | translate }}</span>
      <a class="view-other-periods" (click)="openList.emit(otherPeriodsFilter)" data-testid="contact-plan-view-other-periods">{{ otherPeriodsLinkKey | translate }}</a>
    </div>
    <div class="call-plan" *ngFor="let rp of (previewRows ? (hasNoCurrentPlans ? [] : plan.repPlans | orderBy:'indskr_startdate':false:'productName':true | slice:0:previewRows) : (plan.repPlans | orderBy:'cycleplanname':true)); trackBy: trackById ">
      <div class="primary-content">
        <div class="plan-info">
          <ion-text class="primary-text">{{ rp.title}}
          <ion-icon class="arrow-icon"  class="customer-arrow-icon" name="chevron-forward-outline" (click)="openCustomerCallPlanSuggest(rp)" data-testid="call-plan-overview-open-rep-plan"></ion-icon>
          </ion-text>
          <ion-text class="small-text">{{ rp.duration }}</ion-text>
          <ion-text class="small-text" *ngIf="showPositionName && rp.positionName">{{ rp.positionName }}</ion-text>
        </div>
        <div class="total" *ngIf="rp.goals?.length > 1">
          <div class="title small-text">{{'TOTAL' | translate}}</div>
          <div class="value">
            <div class="completed"> {{rp.completedGoals}}</div>
            <div class="defined">/{{rp.definedGoals}}</div>
          </div>
        </div>
        <div class="percent" *ngIf="rp.goals?.length > 1"
          [ngStyle]="goalStyle(goalPct(rp.percentage, rp.definedGoals))">
          {{ percentageLabel(goalPct(rp.percentage, rp.definedGoals)) }}
        </div>
      </div>
      <div class="secondary-content">
        <div class="goal-item" *ngFor="let g of rp.goals; trackBy: trackById">
          <div class="title small-text">{{g.title | translate}}</div>
          <div class="value">
            <div class="completed" [ngStyle]="goalStyleFor(g.actual, g.goal)">
              {{ goalPercentageLabel(g.actual, g.goal) }} ({{ g.actual }}/{{ g.goal }})
            </div>
          </div>
        </div>
      </div>
      <div class="separationLine"></div>
    </div>
  </ion-item-group>
</div>
